import * as React from 'react';
import Image from 'components/Image';
import Button from 'components/ButtonDeprecated';
import GoogleAPI from 'lib/GoogleAPI';
import AuthActions from 'auth/AuthActions';
import ToastActions from 'actions/ToastActions';
import LoadingModal from 'components/LoadingModal';

import './styles/GoogleSignIn.scss';

type Props = {
  body?: string;
  onSuccess?: () => void;
  mergeToken?: string | null;
  eventKey?: string;
};

class GoogleSignIn extends React.Component<
  Props,
  {
    loading: boolean;
  }
> {
  state: {
    loading: boolean;
  } = { loading: false };

  static defaultProps = {
    body: 'Log in with Google',
    onSuccess: () => undefined,
  };

  componentDidMount() {
    const result = GoogleAPI.consumeRedirectResult();
    if (!result) {
      return;
    }
    // GIS cancel returns to /log_in?error=access_denied. The old popup
    // just closed; do not toast that as a failed login.
    if (result.error === 'access_denied') {
      return;
    }
    if (result.error || !result.code) {
      this.handleAuthorizationError();
      return;
    }
    this.handleAuthorizationCode(result.code, result.mergeToken);
  }

  handleAuthorizationCode = (
    code: string,
    mergeToken: string | null | undefined = this.props.mergeToken
  ) => {
    this.setState({ loading: true });
    AuthActions.googleSignIn(code, mergeToken)
      .then(() => {
        // Join/sign-up continue on SignInPage after AUTH_SUCCESS. Clear the
        // modal here so a failed subscribe cannot leave /log_in blocked.
        this.setState({ loading: false });
        if (this.props.onSuccess) {
          this.props.onSuccess();
        }
      })
      .catch(this.handleAuthorizationError);
  };

  handleAuthorizationError = () => {
    this.setState({ loading: false });
    ToastActions.showErrorToast(
      'There was an error logging in with Google. Please try again later.'
    );
  };

  handleClick = () => {
    this.setState({ loading: true });
    GoogleAPI.startAuthorization({ mergeToken: this.props.mergeToken }).catch(
      this.handleAuthorizationError
    );
  };

  render() {
    return (
      <div>
        {this.state.loading && <LoadingModal />}
        <Button
          type="button"
          color="paper"
          full
          level="secondary"
          className="GoogleSignIn"
          eventElementName="GoogleSignIn"
          onClick={this.handleClick}
          eventKey={this.props.eventKey}
        >
          <Image src={require('assets/images/superg.svg')} className="GoogleSignIn-logo" />
          {this.props.body}
        </Button>
      </div>
    );
  }
}

export default GoogleSignIn;
